import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getCompaniesWithExceptionsRequest,
  getCurrentWageIndexationDataRequest,
  getWageIndexationDataPreviewRequest,
  previewAffectedCompaniesRequest,
  updateWageIndexationDataRequest,
} from 'api/requests/wage-indexation-requests';
import {
  AffectedCompanyModel,
  CompaniesWithExceptionsFilter,
  CompanyExceptionModel,
  PreviewAffectedCompaniesFilter,
  UpdateWageIndexationModel,
  WageIndexationFilterProps,
} from 'modules/payroll-settings/wage-indexation/types';
import {
  WAGE_INDEXATION__GET_COMPANIES_WITH_EXCEPTIONS,
  WAGE_INDEXATION__GET_WAGE_INDEXATION,
  WAGE_INDEXATION__GET_WAGE_INDEXATION_PREVIEW,
  WAGE_INDEXATION__GET_WAGE_INDEXATION_PREVIEW_COMPANIES,
  WAGE_INDEXATION__SET_LOADING_WAGE_INDEXATION,
  WAGE_INDEXATION__SET_WAGE_INDEXATION,
  WAGE_INDEXATION__SET_WAGE_INDEXATION_PREVIEW,
  WAGE_INDEXATION__SET_WAGE_INDEXATION_PREVIEW_COMPANIES,
  WAGE_INDEXATION__UPDATE_WAGE_INDEXATION,
} from 'store/constants';
import { IMinimumWage } from 'types/minimum-wage';

export const setLoadingWageIndexationAction = createAction<boolean>(WAGE_INDEXATION__SET_LOADING_WAGE_INDEXATION);

export const setWageIndexationDataAction = createAction<IMinimumWage[]>(WAGE_INDEXATION__SET_WAGE_INDEXATION);
export const getWageIndexationDataAction = createAsyncThunk(
  WAGE_INDEXATION__GET_WAGE_INDEXATION,
  async (props: WageIndexationFilterProps, thunkApi) => {
    thunkApi.dispatch(setLoadingWageIndexationAction(true));
    try {
      const data = await getCurrentWageIndexationDataRequest(props);
      thunkApi.dispatch(setWageIndexationDataAction(data));
    } catch (e) {
      console.log(e);
    }
    thunkApi.dispatch(setLoadingWageIndexationAction(false));
  },
);

export const setWageIndexationPreviewAction = createAction<IMinimumWage[]>(
  WAGE_INDEXATION__SET_WAGE_INDEXATION_PREVIEW,
);
export const getWageIndexationPreviewAction = createAsyncThunk(
  WAGE_INDEXATION__GET_WAGE_INDEXATION_PREVIEW,
  async (props: WageIndexationFilterProps, thunkApi) => {
    thunkApi.dispatch(setLoadingWageIndexationAction(true));
    try {
      const data = await getWageIndexationDataPreviewRequest(props);
      thunkApi.dispatch(setWageIndexationPreviewAction(data));
    } catch (e) {
      console.log(e);
    }
    thunkApi.dispatch(setLoadingWageIndexationAction(false));
  },
);

export const setPreviewAffactedCompaniesAction = createAction<AffectedCompanyModel[]>(
  WAGE_INDEXATION__SET_WAGE_INDEXATION_PREVIEW_COMPANIES,
);

export const previewAffactedCompaniesAction = createAsyncThunk(
  WAGE_INDEXATION__GET_WAGE_INDEXATION_PREVIEW_COMPANIES,
  async (props: PreviewAffectedCompaniesFilter, thunkApi) => {
    thunkApi.dispatch(setLoadingWageIndexationAction(true));

    try {
      const data = await previewAffectedCompaniesRequest({ filter: props });
      thunkApi.dispatch(setPreviewAffactedCompaniesAction(data));
    } catch (e) {
      console.log(e);
    }

    thunkApi.dispatch(setLoadingWageIndexationAction(false));
  },
);

export const setCompaniesWithExceptionsAction = createAction<CompanyExceptionModel[]>(
  WAGE_INDEXATION__GET_COMPANIES_WITH_EXCEPTIONS,
);

export const getCompaniesWithExceptionsAction = createAsyncThunk(
  WAGE_INDEXATION__GET_COMPANIES_WITH_EXCEPTIONS,
  async (props: CompaniesWithExceptionsFilter, thunkApi) => {
    thunkApi.dispatch(setLoadingWageIndexationAction(true));

    try {
      const data = await getCompaniesWithExceptionsRequest(props);
      thunkApi.dispatch(setCompaniesWithExceptionsAction(data));
    } catch (e) {
      console.log(e);
    }

    thunkApi.dispatch(setLoadingWageIndexationAction(false));
  },
);

export const updateWageIndexationAction = createAsyncThunk(
  WAGE_INDEXATION__UPDATE_WAGE_INDEXATION,
  async (props: { data: UpdateWageIndexationModel }, thunkApi) => {
    thunkApi.dispatch(setLoadingWageIndexationAction(true));
    try {
      await updateWageIndexationDataRequest(props.data);
    } catch (e) {
      console.log(e);
    }
    thunkApi.dispatch(setLoadingWageIndexationAction(false));
  },
);
